import React from 'react';
import './styles.css';

function Services() {
  const servicesData = [
    {
      id: 1,
      icon: '💻',
      title: 'Identité Visuelle',
      subTitle: 'Création de logos, chartes graphiques et visuels professionnels',
      description: 'Votre marque mérite une identité unique, authentique et mémorable. Une image cohérente et soignée est conçue pour renforcer votre crédibilité et vous distinguer sur votre marché.'
    },
    {
      id: 2,
      icon: '🎬',
      title: 'Montage Vidéo Professionnel',
      subTitle: 'Transformez vos séquences brutes en contenus percutants',
      description: 'Chaque capsule est montée avec soin : rythme maîtrisé, effets visuels pertinents, textes dynamiques, mise en scène impactante. L’objectif ? Captiver votre audience sur toutes les plateformes.'
    },
    {
      id: 3,
      icon: '📹',
      title: 'Création de Contenu Vidéo Marketing Sur-Mesure',
      subTitle: 'Des vidéos qui attirent, racontent et convertissent',
      description: 'De la conception à la finalisation, des vidéos modernes, structurées et prêtes à être diffusées. Un contenu taillé pour promouvoir votre marque, vos services ou vos valeurs — en ligne ou sur vos réseaux sociaux.'
    },
    {
      id: 4,
      icon: '✍️',
      title: 'Storytelling Stratégique',
      subTitle: 'Des récits puissants qui marquent les esprits',
      description: 'Chaque texte est conçu pour susciter l’émotion, créer de la connexion et inspirer l’action. Adapté à votre audience, votre positionnement et votre univers.'
    },
    {
      id: 5,
      icon: '🧠',
      title: 'Coaching & Formations',
      subTitle: 'Accompagnement sur vos enjeux créatifs et marketing',
      description: 'Des sessions claires, structurées et actionnables vous aident à développer vos compétences en storytelling, montage vidéo, branding, création de contenu et marketing digital. Objectif : autonomie + stratégie.'
    },
    {
      id: 6,
      icon: '🌐',
      title: 'Création de Site Web Professionnel',
      subTitle: 'Un site esthétique, stratégique et rapide, pensé pour convertir',
      description: 'Site vitrine, portfolio, e-commerce : création clé-en-main orientée résultats. Design moderne, contenu engageant, SEO intégré, expérience fluide pour vos visiteurs.'
    }
  ];

  return (
    <section id="services" className="services">
      <div className="services-container">
        <div className="section-title">
          <h2>Nos Services</h2>
          <p>Découvrez notre gamme complète de services technologiques conçus pour répondre à vos besoins spécifiques.</p>
        </div>
        <div className="services-grid">
          {servicesData.map(service => (
            <div className="service-card" key={service.id}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <h5>{service.subTitle}</h5>
              <p>{service.description}</p>
              <a href="#contact" className="service-link">En savoir plus</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;